import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAPI } from '../../API';
import { ActionTypes, useAppDispatch, useAppState } from '../../Store';
import { useTranslation } from '../../Translation';
import SidebarNav from '../../Components/SidebarNav/SidebarNav';
import SettingSidebarNav from '../../Components/SidebarNav/SettingSidebarNav';
import useAuthenticated from '../Dashboard/useAuthenticated';
import { TextInput } from '../../Components/Inputs/TextInput';
import { Button } from '../../Components/Buttons';
import LoadingCircleTransparent from '../../Components/LoadingIndicators/LoadingCircleTransparent';

export default function General() {


    const { translate, language, setLanguage } = useTranslation();
    const api = useAPI();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const appState = useAppState();
    const [password, setPassword] = useState();
    const { user } = appState;
    const [loading, setLoading] = useState(false);

    const { isAuthenticated, pathAfterLogin } = useAuthenticated();

    const handleChangePassword = async () => {
        setLoading(true);
        const response = await api.updateUser({
            ...user,
            password: password
        });

        dispatch({
            type: ActionTypes.SET_USER,
            payload: response.data
        });

        setPassword('');

        dispatch({
            type: ActionTypes.SET_NOTIFICATION,
            payload: {
                show: true,
                title: translate('setting.general.change_password'),
                message: translate('setting.general.change_password_success'),
                type: 'success'
            }
        });

        setLoading(false);
    }

    return (
        <div className="flex min-h-full w-full">
            <SidebarNav currentPage="settings" contentPadding={false}>
                <div className='flex-1 flex-row h-full w-full'>
                    <SettingSidebarNav currentPage="general" />


                    <div className='flex-1 flex flex-col ml-24 md:ml-72'>
                        <div className='flex flex-col p-2 md:p-4 lg:p-6 w-full'>
                            <div className='flex flex-row justify-between'>
                                <div>
                                    <h3 className='text-2xl font-bold'>{translate('setting.general.title')}</h3>
                                    <p className='text-md text-gray-500 max-w-4xl'>{translate('setting.general.description')}</p>
                                </div>
                            </div>
                            <div className='flex-1 flex flex-col w-full'>
                                <div className='flex flex-col mt-8 pr-8 max-w-md'>
                                    {loading && <div className="flex justify-center items-center h-full w-12">
                                        <LoadingCircleTransparent />
                                    </div>}
                                    <TextInput type="password" label={translate('setting.general.password')} placeholder={translate('setting.general.password_placeholder')} value={password} onChange={(e) => setPassword(e.target.value)} />
                                    <div className='flex flex-row justify-end mt-2'>
                                        <Button onClick={handleChangePassword}>{translate('setting.general.change_password')}</Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </SidebarNav>
        </div>

    );
}